module.exports = __webpack_public_path__ + "media/images/admin/icons/list-950ce93558c72678760d4f5a8186f631.svg";